import api from '../token';

export const ListServico = async (payload) => {
  try {
    const response = await api.post('/getServico',payload);
    return response.data;
  } catch (error) {
   
    return [];
  }
};

